<div class="content">
  <div class="modal-header">
    <h4 class="modal-title full-width ">
      <span *ngIf="!paymentDone">Please enter Your CVV to proceed</span>
      <span *ngIf="paymentDone">Success</span>
    </h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <div *ngIf="!paymentDone">
          <form #cvvForm="ngForm">
            <input class="form-control" placeholder="CVV" maxlength="4" minlength="3" required appNumberOnly type="password" name="cvvNo" [(ngModel)]="cvvNo" />
          </form>
        </div>
        <div class="align-items-center text-center" *ngIf="paymentDone">
          <div>
            <i class="fa fa-check-circle custom-icon" [style.color]="'green'"></i>
          </div>
          <h3 class="mt-2">
            <span>Payment Successful</span>
          </h3>
          <table class="table table-sm table-bordered table-hover m-0 text-nowrap nowrap table-sortable"
            *ngIf="paymentResp">
            <tbody>
              <ng-container *ngFor="let resp of paymentResp">
                <tr *ngIf="allowedKeysToDisplay.indexOf(resp.key) !== -1">
                  <td>
                    {{resp.key}}
                  </td>
                  <td>
                    {{resp.data}}
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <!-- <ng-container *ngIf="paymentErrorResp">
            {{paymentErrorResp | json }}
          </ng-container> -->

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="button-list">
      <button *ngIf="!paymentDone" type="button" class="btn btn-sm  fis-btn" [disabled]="loading || !cvvNo || cvvNo.length < 3"
        (click)="doPayment()"> Proceed To Pay
      </button>
      <button *ngIf="paymentDone" type="button" class="btn btn-sm  fis-btn" (click)="activeModal?.close(null)">Close
      </button>
    </div>
  </div>
  <div class="card-disabled" *ngIf="loading">
    <div class="card-portlets-loader">
      <div class="spinner-border text-primary m-2" role="status"></div>
    </div>
  </div>
</div>
